"use client";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { loadingWithFacts } from "./Helper";

const ApiLoader = ({ gif: _gif }: { gif?: string }) => {
  const [mounted, setMounted] = useState(false);
  const [factIndex, setFactIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => { setMounted(true); }, []);

  useEffect(() => {
    const id = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setFactIndex(i => (i + 1) % loadingWithFacts.length);
        setVisible(true);
      }, 350);
    }, 4000);
    return () => clearInterval(id);
  }, []);

  if (!mounted) return null;

  return createPortal(
    <div className="fixed inset-0 z-[2147483647] bg-white flex flex-col items-center justify-center">

      {/* Loading Spinner */}
      <svg
        className="size-12 md:size-16 animate-spin text-[#1776F0]"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>

      {/* Text & Rotating Facts */}
      <p className="ff_poppins font-semibold text-base lg:text-lg xl:text-xl text-black text-center mt-5">
        Hang Tight!
      </p>
      <p
        className="ff_poppins text-sm lg:text-base xl:text-lg text-center px-6 text-[#6B7280] mt-2 max-w-[340px]"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(5px)",
          transition: "opacity 0.35s ease, transform 0.35s ease",
          minHeight: 52,
        }}
      >
        {loadingWithFacts[factIndex].title}
      </p>
    </div>,
    document.body,
  );
};

export default ApiLoader;
